import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule } from '../../shared/shared.module';
import { JobcostingComponent } from './component/jobcosting/jobcosting.component';
import { InspectionsScheduledComponent } from './component/inspections-scheduled/inspections-scheduled.component';
import { PayrollComponent } from './component/payroll/payroll.component';
import { AccountingReportPayrollComponent } from './component/accounting-report-payroll/accounting-report-payroll.component';
import { EstimatedActualComponent } from './component/estimated-actual/estimated-actual.component';

/**
 * The reports that also appear as widgets on the old admin dashboard and home pages
 * (<app-jobcosting [count]> ...). Those pages are in AppModule, so these five load with the app;
 * every report page (these included) is routed by the lazy ReportsModule.
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    NgbModule,
    SharedModule,
  ],
  declarations: [
    JobcostingComponent,
    InspectionsScheduledComponent,
    PayrollComponent,
    AccountingReportPayrollComponent,
    EstimatedActualComponent,
  ],
  exports: [
    JobcostingComponent,
    InspectionsScheduledComponent,
    PayrollComponent,
    AccountingReportPayrollComponent,
    EstimatedActualComponent,
  ]
})
export class ReportWidgetsModule { }
